var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1614)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_1614)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89982 17.32C6.30982 18.24 7.99983 18.77 9.80982 18.77C14.7698 18.77 18.7898 14.76 18.7898 9.80998C18.7898 4.85998 14.7598 0.849976 9.79982 0.849976C4.83982 0.849976 0.819824 4.85998 0.819824 9.80998C0.819824 11.75 1.26982 13.31 2.31982 14.77L1.28982 18.08L4.88982 17.31L4.89982 17.32Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9299 8.56995C21.4699 9.83995 23.2099 12.4699 23.2099 15.4899C23.2099 17.1699 22.8199 18.5099 21.9099 19.7799L22.7999 22.6399L19.6899 21.9799C18.4699 22.7699 17.0099 23.2399 15.4499 23.2399C12.3399 23.2399 9.65992 21.4099 8.41992 18.7799",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 1,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageCircleFill);
export default __webpack_public_path__ + "static/media/icon-message-circle-fill.6b185e97cb7fad3e422a0655815aa5cf.svg";
export { ForwardRef as ReactComponent };